import { Component, inject } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { NgStyle, TitleCasePipe } from '@angular/common';
import { Observable } from 'rxjs/internal/Observable';
import { ResponsiveService } from '../../services/reponsive.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PricingComponent } from '../../components/pricing/pricing.component';
import { Store } from '@ngrx/store';
import { selectClientTokensPerMonth } from '../../store/client/client.selects';
import { Plan } from '../../class/plan.class';
import { of } from 'rxjs';
import { ButtonComponent } from '../../components/boutons/button/button.component';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { TokensPacksModalComponent } from '../../components/modals/tokens-packs-modal/tokens-packs-modal.component';
import { StripeCheckoutService } from '../../services/stripe-checkout.service';
import { TokensPack } from '../../class/tokensPack.class';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-plans',
  imports: [
    LucideAngularModule,
    TranslateModule,
    NgStyle,
    PricingComponent,
    ButtonComponent,
    TitleCasePipe,
  ],
  templateUrl: './plans.component.html',
  styleUrl: './plans.component.scss',
})
export class PlansComponent {
  private responsiveService: ResponsiveService = inject(ResponsiveService);
  private store: Store = inject(Store);
  private translateService: TranslateService = inject(TranslateService);
  private stripeCheckoutService: StripeCheckoutService = inject(
    StripeCheckoutService
  );
  private dialog: Dialog = inject(Dialog);

  isDesktop$: Observable<boolean> = this.responsiveService.desktop$;
  tokensPerMonth$: Observable<number> = this.store.select(
    selectClientTokensPerMonth
  );
  tokensPacks$: Observable<TokensPack[]> = of([]);
  discordUrl: string = environment.socials.discord_url;

  openTokensPackModal() {
    const dialogRef: DialogRef<unknown, TokensPacksModalComponent> =
      this.dialog.open(TokensPacksModalComponent, {
        width: '500px',
      });
    const tokensPacksModalComponent =
      dialogRef.componentInstance as TokensPacksModalComponent;
    // tokensPacksModalComponent.content = this.translateService.instant('modal.delete_job.content');
    // tokensPacksModalComponent.confirm = this.translateService.instant('modal.delete_job.confirm');
    tokensPacksModalComponent.tokensPackClick.subscribe(
      (tokenPack: TokensPack) => {
        this.stripeCheckoutService.checkoutTokensPack(tokenPack.priceId);
        dialogRef.close();
      }
    );
  }

  useBetaCode(): void {
    this.stripeCheckoutService.checkoutTokensPack(
      'price_1SE9ZTR1X5dLdyWjAQtPGg85'
    );
  }
}
